const EXCLUDED_PREFIXES = ['/organizations', '/facilities', '/facility-wizard', '/onboarding'];

/**
 * True when the given URL is one of the routes where the "no facility selected"
 * gate should NOT activate (because the user would go there to fix the problem).
 * Matches on path only; query string is stripped before comparison.
 *
 * Matching rules: exact match OR the URL continues with a `/` after the prefix.
 * So `/facilities-archive` is NOT excluded but `/facilities/upsert/123` is.
 */
export function isUpsertRoute(url: string): boolean {
  const isUpsert = url.includes('/upsert');

  return isUpsert;
}

export function isFacilityGateExcludedRoute(url: string): boolean {
  const path = url.split('?')[0];
  return EXCLUDED_PREFIXES.some(
    prefix => path === prefix || path.startsWith(prefix + '/'),
  );
}
